// extracted by mini-css-extract-plugin
module.exports = {"container":"Banner_container__3eQMm","body":"Banner_body__3ovrX","slideItem":"Banner_slideItem__AUMvx"};